// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"413":"3e1edd38","426":"b2970145","552":"3297c624","674":"4afb09e1","808":"b3cc36a3"}[chunkId] + ".chunk.css";
};